import { createAppAsyncThunk } from '@/admin/helpers';
import { UploadSurplusItemsStepIndex } from '@/admin/modules/stockReceipt/models';
import { t } from '@/core/localization';
import { getErrorFromException } from '@/core/utils/errorHandling';
import { enqueueSnackbar } from 'notistack';
import { stockReceiptApi } from '../stockReceipt.api';
import { stockReceiptActions } from '../stockReceipt.state';
/**
 * Uploads surplus items and gets **parsed** surplus items data with settings.
 */
const uploadSurplusItemsAndGetSettings = createAppAsyncThunk('stockReceipt/uploadSurplusItemsAndGetSettings', async (file, { dispatch }) => {
    dispatch(stockReceiptActions.setIsSurplusItemsRequestFetching(true));
    try {
        const surplusItemsPreview = await dispatch(stockReceiptApi.endpoints.uploadSurplusAndGetPreview.initiate(file)).unwrap();
        dispatch(stockReceiptActions.setSurplusItemsPreview({ surplusItemsPreview }));
    }
    catch (error) {
        const uploadErrorMessage = getErrorFromException(error);
        dispatch(stockReceiptActions.setSurplusItemsPreview({ uploadErrorMessage }));
        enqueueSnackbar({
            variant: 'error',
            header: t('upload.surplus.items.file.upload.failed'),
            body: getErrorFromException(error),
            persist: true,
        });
        dispatch(stockReceiptActions.setIsSurplusItemsRequestFetching(false));
        return;
    }
    dispatch(stockReceiptActions.setSurplusItemsUploadStep(UploadSurplusItemsStepIndex.CellMapping));
    dispatch(stockReceiptActions.setIsSurplusItemsRequestFetching(false));
});
export { uploadSurplusItemsAndGetSettings };
